import api from '../api';

const endpoint = '/student-management/young-apprentice/invoice-notes';
const YoungApprenticeInvoiceNotesService = {
  get: () => api.get(endpoint).then(response=>response.data),
  save: payload => api.put(endpoint,payload).then(response=>response.data),
};
export default YoungApprenticeInvoiceNotesService;
